// context/ApiContext.tsx
import React, { createContext, ReactNode, useContext } from 'react';
import { useNavigate, NavigateFunction } from 'react-router-dom';

interface ApiContextProps {
  navigate: NavigateFunction;
}

const ApiContext = createContext<ApiContextProps | undefined>(undefined);

export const useApiContext = () => {
  const context = useContext(ApiContext);
  if (!context) throw new Error("useApiContext must be used within ApiProvider");
  return context;
};

export const ApiProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <ApiContext.Provider value={{ navigate }}>
      {children}
    </ApiContext.Provider>
  );
};
